import { type FC } from 'react';
import { react2Angular } from 'FrontRoyalReact2Angular';
import { type AnyObject } from '@Types';
import { FreeResponsePlayerUi } from '../../FreeResponsePlayerUi';
import { FreeResponseEditor } from '../../FreeResponseEditor';
import { FreeResponseButton } from '../../FreeResponseButton';

const angularModule = angular.module('FreeResponseFrame', []);

angularModule.component(
    'freeResponsePlayerUi',

    // See comment at the top of FreeResponsePlayerUiComponent for why we need h-full and w-full here
    react2Angular(FreeResponsePlayerUi as unknown as FC<AnyObject>, ['frameViewModel'], 'h-full w-full'),
);
angularModule.component(
    'freeResponseEditor',
    react2Angular(FreeResponseEditor as unknown as FC<AnyObject>, ['frameViewModel'], ''),
);
angularModule.component(
    'freeResponseButton',
    react2Angular(FreeResponseButton as unknown as FC<AnyObject>, ['playerViewModel', 'frameViewModel'], ''),
);

export default angularModule;
